export default [
  {
    path: "/home",
    name: "home",
    component: () => import("../../views/Home.vue"),
  },
  {
    path: "/",
    redirect: "/apps",
  },
  {
    path: "/apps",
    name: "page-2",
    component: () => import("../../views/apps/Apps.vue"),
  },
  {
    path: "/kuisioner-institusi",
    name: "kuisioner-institusi",
    component: () => import("../../views/apps/Kuisioner.vue"),
    meta: {
      pageTitle: "Kuisioner Pengembangan Institusi",
    },
  },
  {
    path: "/submenu/:menuUrl",
    name: "submenu",
    component: () => import("../../views/apps/Submenu.vue"),
  },
  {
    path: "/pegawai/profil",
    name: "pegawai-profile",
    component: () => import("../../views/apps/PegawaiProfile.vue"),
  },

  {
    path: "/pegawai/sunting-profil",
    name: "pegawai-sunting-profil",
    component: () => import("../../views/apps/EditPegawaiProfil.vue"),
  },
  {
    path: "/mahasiswa/profil",
    name: "mahasiswa-profile",
    component: () => import("../../views/apps/MahasiswaProfile.vue"),
  },

  {
    path: "/mahasiswa/sunting-profil",
    name: "mahasiswa-sunting-profile",
    component: () => import("../../views/apps/EditMahasiswaProfil.vue"),
  },
  {
    path: "/pegawai/ganti-password",
    name: "pegawai-ganti-password",
    component: () => import("../../views/dosen/profil/GantiPassword.vue"),
    meta: {
      pageTitle: "Ganti Password",
    },
  },
];
